<template>
  <div>
    <h1>Top Page</h1>
    <p><a href="/.auth/logout">Logout</a></p>
    <p>{{ user }}</p>
    <div id="nav" class="tab-area-base">
      <ul class="tab-menu-base">
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/login">Login</router-link></li>
        <li><router-link to="/time">Timer</router-link></li>
        <li><router-link to="/fortune">Fortune</router-link></li>
      </ul>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: "ログインしていません"
    }
  },
  mounted: function() {
    this.$nextTick(function(){
      this.axios.get('/.auth/me')
        .then((response) => {
          alert(response.data.clientPrincipal);
          if(response.data.clientPrincipal){
            this.user = response.data.clientPrincipal.userId;
            this.$store.dispatch("auth", {
              userId: this.user,
              userToken: 'TOKEN'
            });
          }
          else{
            this.user = "ログインしていません"
            this.$store.dispatch("auth", {
              userId: null,
              userToken: null
            });
          }
        })
        .catch((e) => {
          alert(e);
        });
    })
  }
}
</script>